export interface IAdfoxConstants {
  p1: string;
  p2: string;
  pct: string;
  pfc: string;
  pfb: string;
  plp: string;
  pli: string;
  pop: string;
  pt: string;
}

export const adfoxMediaConstants: IAdfoxConstants = {
  p1: 'buxfk',
  p2: 'fjjq',
  pct: 'a',
  pfc: 'a',
  pfb: 'a',
  plp: 'a',
  pli: 'a',
  pop: 'a',
  pt: 'b',
};

export const adfoxJKConstants: IAdfoxConstants = {
  p1: 'buldx',
  p2: 'fice',
  pct: 'a',
  pfc: 'a',
  pfb: 'a',
  plp: 'a',
  pli: 'a',
  pop: 'a',
  pt: 'b',
};

export const adfoxMortgageConstants = {
  p1: 'caabh',
  p2: 'fwcw',
};
